import React from "react";
import "./style.scss";
import { useGetAboutBannerQuery } from "../../../services/AboutAPI";
import Loader from "../fullPageLoader"

function Index() {
  const { data, error, isLoading } = useGetAboutBannerQuery();

  if (isLoading) return <Loader />;
  if (error) return <p>Failed to load data</p>;

  // Assuming 'data' contains the banners for different pages
  const cartBanner = data?.data?.find((item) => item.page_name === "Cart");

  return (
    <div
      className="shop"
      style={{
        backgroundImage: `url(${cartBanner?.banner_image})`,
        backgroundSize: "cover",

      }}
    >
      <section className="shop-banner">
        <div className="banner-overlay"></div>
        <div className="container">

          <div className="banner-heading">
            <h1>
              Cart
            </h1>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Index;
